module.exports = __webpack_public_path__ + "static/assets/0f8daf98572baa254efa464fe4978177.png";